var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Injectable } from '@angular/core';
import { BaseProvider } from './base';
import { UserProvider } from './user';
import { SettingsProvider } from './settings';
var DEFAULT_LANGUAGE_CODE = 'en';
var languagesSupported = [
    {
        code: 'en',
        name: 'English',
        nativeTranslatedName: 'English'
    },
    {
        code: 'ja',
        name: 'Japanese',
        nativeTranslatedName: '日本語'
    }
];
var TranslationProvider = /** @class */ (function (_super) {
    __extends(TranslationProvider, _super);
    function TranslationProvider(translate, userProvider, settingsProvider) {
        var _this = _super.call(this) || this;
        _this.translate = translate;
        _this.userProvider = userProvider;
        _this.settingsProvider = settingsProvider;
        _this.initializeTranslation();
        return _this;
    }
    /**
     * Set the current and default language for the app
     */
    TranslationProvider.prototype.initializeTranslation = function () {
        this.translate.setDefaultLang(DEFAULT_LANGUAGE_CODE);
        this.setLanguageFromSystem();
    };
    /**
     * Set the language for the app based on the language specified by
     * the user, browser, system or default
     */
    TranslationProvider.prototype.setLanguageFromSystem = function () {
        var languageToUse = this.getSelectedLanguageCode();
        this.setTranslationLanguage(languageToUse);
    };
    /**
     * Return the list of languages available for selection in the app.
     * The currently selected language will be marked as such
     */
    TranslationProvider.prototype.getSelectableLanguages = function () {
        var selectedLanguageCode = this.getSelectedLanguageCode();
        return languagesSupported.map(function (spec) {
            return __assign({}, spec, { selected: spec.code === selectedLanguageCode });
        });
    };
    /**
     * Return the language selected for use in the app
     */
    TranslationProvider.prototype.getSelectedLanguageCode = function () {
        var requestedLanguage = this.getUserLanguageCode() || this.getSystemLanguageCode();
        if (this.isLanguageSupported(requestedLanguage)) {
            return requestedLanguage;
        }
        return DEFAULT_LANGUAGE_CODE;
    };
    /**
     * Set the current language for the app
     */
    TranslationProvider.prototype.setTranslationLanguage = function (languageCode) {
        this.translate.use(languageCode);
    };
    /**
     * Set the user's language preference
     */
    TranslationProvider.prototype.setUserLanguageCode = function (languageCode) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isLanguageSupported(languageCode)) {
                            throw new Error("Language code " + languageCode + " is not supported");
                        }
                        return [4 /*yield*/, this.settingsProvider.set('locale', languageCode)];
                    case 1:
                        _a.sent();
                        this.setLanguageFromSystem();
                        return [2 /*return*/];
                }
            });
        });
    };
    TranslationProvider.prototype.getUserLanguageCode = function () {
        return this.settingsProvider.get('locale') || null;
    };
    TranslationProvider.prototype.getSystemLanguageCode = function () {
        if (navigator && navigator.language) {
            return navigator.language.split('-')[0];
        }
        return DEFAULT_LANGUAGE_CODE;
    };
    TranslationProvider.prototype.isLanguageSupported = function (languageCode) {
        return languagesSupported.some(function (lang) { return lang.code === languageCode; });
    };
    TranslationProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [TranslateService,
            UserProvider,
            SettingsProvider])
    ], TranslationProvider);
    return TranslationProvider;
}(BaseProvider));
export { TranslationProvider };
/**
 * Use this method in your root module to provide the TranslateService
 */
export function getTranslateModuleForRoot() {
    return TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: createHttpLoader,
            deps: [HttpClient]
        }
    });
}
export function createHttpLoader(http) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
/**
 * Use this method to mark a string for collection into the translation resource files
 * by the localization register command. This function does nothing at runtime
 *
 * @returns The same value as the key passed in
 */
export function resourceString(key) {
    return key;
}
//# sourceMappingURL=translation.js.map


// WEBPACK FOOTER //
// ./src/providers/translation.ts.pre-build-optimizer.js